import request from "./request";

// export let path = 'http://ksadmindev.tiandi.com'
// export let path = 'http://www.wanshang.com/index.php'
export let path = "https://ks.13398.com";
// export let path = 'http://192.168.1.182/index.php'

export function getAdminList(params) {
  return request({
    url: "/api/HotWord/getAdminList",
    method: "get",
    params
  });
}

export function getHotWordInfo(params) {
  return request({
    url: "/api/HotWord/getHotWordInfo",
    method: "get",
    params
  });
}

export function getHotWordByVague(params) {
  return request({
    url: "/api/HotWord/getHotWordByVague",
    method: "get",
    params
  });
}

export function getCateList(params) {
  return request({
    url: "/api/HotWord/getCateList",
    method: "get",
    params
  });
}

export function setHosByOrder(data) {
  return request({
    url: "/api/HotWord/setHosByOrder",
    method: "post",
    data
  });
}

export function getGroupInfo(params) {
  return request({
    url: "/api/HotWord/getGroupInfo",
    method: "get",
    params
  });
}

export function getHosByOrder(data) {
  return request({
    url: "/api/HotWord/getHosByOrder",
    method: "post",
    data
  });
}

export function getNotHotWord(data) {
  return request({
    url: "/api/HotWord/getNotHotWord",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/server/api.js